// import React, { useEffect, useMemo, useState } from "react";
// import * as XLSX from "xlsx";
// import axios from "axios";
// import Sidebar from "./Sidebar";
// import Dashboard from "./Dashboard";
// import Navbar from "./Navbar";
// import Guidelines from "./Guidlines";
// import VerifyCert from "./Verify_Cert";
// import HelpSupport from "./Help_Support";
// import Settings from "./Setting";
// import Profile from "./Profile";
// import "./styles.css";

// function App() {
//   const [data, setData] = useState([]);
//   const [selected, setSelected] = useState({});
//   const [mode, setMode] = useState("dashboard");
//   const [status, setStatus] = useState({});
//   const [preview, setPreview] = useState(null);
//   const [openSidebar, setOpenSidebar] = useState(false);

//   // 🔍 search + debounce
//   const [search, setSearch] = useState("");
//   const [debounced, setDebounced] = useState("");
//   const [drag, setDrag] = useState(false);
//   // 📊 column filter
//   const [filterKey, setFilterKey] = useState("");

//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(search), 250);
//     return () => clearTimeout(t);
//   }, [search]);

//   // Upload Excel
//   const handleFileUpload = (e) => {
//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const wb = XLSX.read(evt.target.result, { type: "binary" });
//       const sheet = wb.Sheets[wb.SheetNames[0]];

//       const json = XLSX.utils
//         .sheet_to_json(sheet, { defval: "" })
//         .filter((row) => Object.values(row).join("").trim() !== "");

//       const init = {};
//       json.forEach((_, i) => (init[i] = true));

//       setData(json);
//       setSelected(init);
//     };
//     reader.readAsBinaryString(e.target.files[0]);
//   };


// const handleExcel = (file) => {
//   if (!file) return;

//   const reader = new FileReader();

//   reader.onload = async (evt) => {
//     const wb = XLSX.read(evt.target.result, { type: "binary" });
//     const sheet = wb.Sheets[wb.SheetNames[0]];

//     const json = XLSX.utils
//       .sheet_to_json(sheet, { defval: "" })
//       .filter((row) => Object.values(row).join("").trim() !== "");

//     // 🔥 IMPORTANT: backend ko bhejo
//     try {
//       await axios.post("http://localhost:5000/save-excel", {
//         data: json,
//       });

//       console.log("Excel sent to server ✅");
//     } catch (err) {
//       console.log("Error sending excel ❌", err);
//     }

//     // existing logic
//     const init = {};
//     json.forEach((_, i) => (init[i] = true));

//     setData(json);
//     setSelected(init);
//   };

//   reader.readAsBinaryString(file);
// };


//   // 🔍 highlight
//   const highlightText = (text) => {
//     if (!debounced) return text;
//     const regex = new RegExp(`(${debounced})`, "gi");
//     return text
//       ?.toString()
//       .split(regex)
//       .map((part, i) =>
//         part.toLowerCase() === debounced.toLowerCase() ? (
//           <span key={i} className="highlight">
//             {part}
//           </span>
//         ) : (
//           part
//         ),
//       );
//   };

//   const toggleSidebar = () => {
//     setOpenSidebar(!openSidebar);
//   };

//   // 🔥 FILTER + INDEX SAFE
//   const filteredData = useMemo(() => {
//     return data
//       .map((row, index) => ({ row, index }))
//       .filter(({ row }) => {
//         const value = filterKey ? row[filterKey] : Object.values(row).join(" ");

//         return value
//           ?.toString()
//           .toLowerCase()
//           .includes(debounced.toLowerCase());
//       });
//   }, [data, debounced, filterKey]);

//   // Toggle checkbox
//   const toggle = (i) => {
//     setSelected((prev) => ({ ...prev, [i]: !prev[i] }));
//   };

//   const selectAll = () => {
//     const all = {};
//     data.forEach((_, i) => (all[i] = true));
//     setSelected(all);
//   };

//   const deselectAll = () => {
//     const none = {};
//     data.forEach((_, i) => (none[i] = false));
//     setSelected(none);
//   };

//   // Send emails
// const sendEmails = async () => {
   
//   const filtered = data.filter((_, i) => selected[i]);

//   if (filtered.length === 0) {
//     alert("Please select at least one record");
//     return;
//   }

//   try {
//     setLoading(true); // 🔥 start loader

//     const res = await axios.post(
//       mode === "offer"
//         ? "http://localhost:5000/send-offers"
//         : "http://localhost:5000/send-certificates",
//       { data: filtered }
//     );

//     // ✅ status update (correct index mapping)
//     const updated = { ...status };
//     filtered.forEach((item) => {
//       const index = data.findIndex(d => d === item);
//       updated[index] = "Sent";
//     });

//     setStatus(updated);

//     alert(res?.data?.message || "Emails Sent Successfully! ✅");

//   } catch (error) {
//     console.error("Error:", error);

//     // 🔥 better error message
//     alert(
//       error?.response?.data?.error ||
//       error?.message ||
//       "Something went wrong ❌"
//     );

//   } finally {
//     setLoading(false); // 🔥 always stop loader
//   }
// };


//   // Download PDF
// const downloadPDF = async (student) => {
//   try {
//     const res = await axios.post(
//       "http://localhost:5000/download-pdf",
//       { student, mode },
//       { responseType: "blob" } // 🔥 VERY IMPORTANT
//     );

//     const blob = new Blob([res.data], { type: "application/pdf" });

//     const url = window.URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${student.Name}.pdf`;
//     a.click();

//   } catch (err) {
//     alert("Download failed ❌");
//     console.log(err);
//   }
// };

// const downloadZip = async () => {
//   const filtered = data.filter((_, i) => selected[i]);

//   if (filtered.length === 0) {
//     alert("Select at least one record");
//     return;
//   }

//   try {
//     const res = await axios.post(
//       "http://localhost:5000/download-zip",
//       { data: filtered },
//       { responseType: "blob" } // 🔥 MUST
//     );

//     const url = window.URL.createObjectURL(new Blob([res.data]));

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "certificates.zip";
//     a.click();

//   } catch (err) {
//     console.log(err);
//     alert("ZIP download failed ❌");
//   }
// };


//   // 📊 stats
// const selectedCount = Object.values(selected).filter(Boolean).length;

//   return (
//     <div className="app">
//       <Sidebar setMode={setMode} openSidebar={openSidebar} mode={mode} />
//       <div className="main">
//         <Navbar
//           mode={mode}
//           setSearch={setSearch}
//           toggleSidebar={toggleSidebar}
//           downloadZip={downloadZip}
//         />
//         {/* DASHBOARD */}
//         {mode === "dashboard" && (
//           <Dashboard data={data} selected={selected} status={status} />
//         )}

//         {/* GUIDELINES */}
//         {mode === "guidelines" && <Guidelines /> }

//         {/* VERIFY CERTIFICATE */}
//         {mode === "verify" && <VerifyCert />}

//         {/* HELP & SUPPORT */}
//         {mode === "help" && <HelpSupport />}

//         {/* SETTINGS */}
//         {mode === "settings" && <Settings />}

//         {/* PROFILE */}
//         {mode === "profile" && <Profile />}

//         {/* TABLE AREA */}
//         {(mode === "offer" || mode === "certificate") && (
//           <>
//             {/* <h2>{mode === "offer" ? "OFFER LETTERS" : "CERTIFICATES"}</h2> */}
//             <h2> </h2>
//             {/* <input type="file" onChange={handleFileUpload} /> */}
//             <div
//               className={`uploadBox ${drag ? "active" : ""}`}
//               onDragEnter={() => setDrag(true)}
//               onDragLeave={() => setDrag(false)}
//               onDragOver={(e) => e.preventDefault()}
//               onDrop={(e) => {
//                 e.preventDefault();
//                 const file = e.dataTransfer.files[0];
//                 handleExcel(file);
//               }}
//               onClick={() => document.getElementById("fileInput").click()}
//             >
//               <p>📂 Drag & Drop Excel File Here</p>
//               <span>or click to upload</span>

//               <input
//                 id="fileInput"
//                 type="file"
//                 accept=".xlsx, .xls"
//                 style={{ display: "none" }}
//                 onChange={(e) => handleExcel(e.target.files[0])}
//               />
//             </div>

//             {/* 📊 FILTER + STATS */}
//             <div className="topControls">
//               <select onChange={(e) => setFilterKey(e.target.value)}>
//                 <option value="">All Columns</option>
//                 {data[0] &&
//                   Object.keys(data[0]).map((k) => <option key={k}>{k}</option>)}
//               </select>

//               <div className="stats">
//                 <span>Total: {data.length}</span>
//                 <span>Filtered: {filteredData.length}</span>
//                 <span>Selected: {selectedCount}</span>
//               </div>
//             </div>

//             <div>
//               <button className="btn" onClick={selectAll}>
//                 Select All
//               </button>
//               <button className="btn" onClick={deselectAll}>
//                 Deselect
//               </button>
//               <button className="btn" onClick={sendEmails} disabled={loading}>
//                 {loading ? <span className="loader"></span> : "📤 Send"}
//               </button>
//             </div>

//             {/* TABLE */}
//             <div className="tableWrap">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Select</th>

//                     {filteredData[0] &&
//                       Object.keys(filteredData[0].row).map((k) => (
//                         <th key={k}>{k}</th>
//                       ))}

//                     <th>Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {filteredData.map(({ row, index }) => (
//                     <tr key={index}>
//                       <td>
//                         <input
//                           type="checkbox"
//                           checked={selected[index] || false}
//                           onChange={() => toggle(index)}
//                         />
//                       </td>

//                       {Object.values(row).map((val, j) => (
//                         <td key={j}>{highlightText(val)}</td>
//                       ))}

//                       <td>
//                         <span
//                           className={
//                             status[index] === "Sent" ? "sent" : "pending"
//                           }
//                         >
//                           {status[index] || "Pending"}
//                         </span>
//                       </td>

//                       <td>
//                         <button onClick={() => setPreview(row)}>👁</button>
//                         <button onClick={() => downloadPDF(row)}>⬇</button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </>
//         )}

//         {/* BULK ACTION BAR */}
//         {selectedCount > 0 && (
//           <div className="bulkBar">
//             {selectedCount} selected
//             <button onClick={sendEmails}>Send</button>
//           </div>
//         )}

//         {/* PREVIEW */}
//         {preview && (
//           <div className="modal">
//             <div className="modalBox">
//               <h2>Preview</h2>
//               <p>{preview.Name}</p>
//               <button onClick={() => setPreview(null)}>Close</button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default App;






// import React, { useEffect, useMemo, useState } from "react";
// import * as XLSX from "xlsx";
// import Sidebar from "./Sidebar";
// import Dashboard from "./Dashboard";
// import Navbar from "./Navbar";
// import Guidelines from "./Guidlines";
// import VerifyCert from "./Verify_Cert";
// import HelpSupport from "./Help_Support";
// import Settings from "./Setting";
// import Profile from "./Profile";

// // 🔥 Hamare naye API services ko import kiya
// import { 
//   uploadExcelData, 
//   sendBulkEmails, 
//   downloadStudentPDF, 
//   downloadCertificatesZip 
// } from "./api/service";

// import "./styles.css";

// function App() {
//   const [data, setData] = useState([]);
//   const [selected, setSelected] = useState({});
//   const [mode, setMode] = useState("dashboard");
//   const [status, setStatus] = useState({});
//   const [preview, setPreview] = useState(null);
//   const [openSidebar, setOpenSidebar] = useState(false);

//   // 🔍 search + debounce
//   const [search, setSearch] = useState("");
//   const [debounced, setDebounced] = useState("");
//   const [drag, setDrag] = useState(false);
//   // 📊 column filter
//   const [filterKey, setFilterKey] = useState("");

//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(search), 250);
//     return () => clearTimeout(t);
//   }, [search]);

//   // Handle Excel Logic (Common for Drag-Drop and Browse)
//   const handleExcel = (file) => {
//     if (!file) return;

//     const reader = new FileReader();

//     reader.onload = async (evt) => {
//       const wb = XLSX.read(evt.target.result, { type: "binary" });
//       const sheet = wb.Sheets[wb.SheetNames[0]];

//       const json = XLSX.utils
//         .sheet_to_json(sheet, { defval: "" })
//         .filter((row) => Object.values(row).join("").trim() !== "");

//       // 🔥 Backend ko data bhejo (Using Central API)
//       try {
//         await uploadExcelData(json);
//         console.log("Excel sent to server ✅");
//       } catch (err) {
//         console.error("Error sending excel ❌", err);
//       }

//       // State updates
//       const init = {};
//       json.forEach((_, i) => (init[i] = true));
//       setData(json);
//       setSelected(init);
//     };

//     reader.readAsBinaryString(file);
//   };

//   // 🔍 highlight text
//   const highlightText = (text) => {
//     if (!debounced) return text;
//     const regex = new RegExp(`(${debounced})`, "gi");
//     return text
//       ?.toString()
//       .split(regex)
//       .map((part, i) =>
//         part.toLowerCase() === debounced.toLowerCase() ? (
//           <span key={i} className="highlight">
//             {part}
//           </span>
//         ) : (
//           part
//         )
//       );
//   };

//   const toggleSidebar = () => {
//     setOpenSidebar(!openSidebar);
//   };

//   // FILTER + INDEX SAFE
//   const filteredData = useMemo(() => {
//     return data
//       .map((row, index) => ({ row, index }))
//       .filter(({ row }) => {
//         const value = filterKey ? row[filterKey] : Object.values(row).join(" ");
//         return value
//           ?.toString()
//           .toLowerCase()
//           .includes(debounced.toLowerCase());
//       });
//   }, [data, debounced, filterKey]);

//   // Toggle checkbox
//   const toggle = (i) => {
//     setSelected((prev) => ({ ...prev, [i]: !prev[i] }));
//   };

//   const selectAll = () => {
//     const all = {};
//     data.forEach((_, i) => (all[i] = true));
//     setSelected(all);
//   };

//   const deselectAll = () => {
//     const none = {};
//     data.forEach((_, i) => (none[i] = false));
//     setSelected(none);
//   };

//   // Send emails
//   const sendEmails = async () => {
//     const filtered = data.filter((_, i) => selected[i]);

//     if (filtered.length === 0) {
//       alert("Please select at least one record");
//       return;
//     }

//     try {
//       setLoading(true);

//       // 🔥 Call Central Email Service
//       const res = await sendBulkEmails(filtered, mode);

//       // status update
//       const updated = { ...status };
//       filtered.forEach((item) => {
//         const index = data.findIndex((d) => d === item);
//         updated[index] = "Sent";
//       });
//       setStatus(updated);

//       alert(res?.data?.message || "Emails Sent Successfully! ✅");
//     } catch (error) {
//       console.error("Error:", error);
//       alert(
//         error?.response?.data?.error ||
//           error?.message ||
//           "Something went wrong ❌"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Download PDF
//   const downloadPDF = async (student) => {
//     try {
//       // 🔥 Call Central PDF Service
//       const res = await downloadStudentPDF(student, mode);

//       const blob = new Blob([res.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);

//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `${student.Name}.pdf`;
//       a.click();
//     } catch (err) {
//       alert("Download failed ❌");
//       console.error(err);
//     }
//   };

//   // Download ZIP
//   const downloadZip = async () => {
//     const filtered = data.filter((_, i) => selected[i]);

//     if (filtered.length === 0) {
//       alert("Select at least one record");
//       return;
//     }

//     try {
//       // 🔥 Call Central ZIP Service
//       const res = await downloadCertificatesZip(filtered);

//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "certificates.zip";
//       a.click();
//     } catch (err) {
//       console.error(err);
//       alert("ZIP download failed ❌");
//     }
//   };

//   const selectedCount = Object.values(selected).filter(Boolean).length;

//   return (
//     <div className="app">
//       <Sidebar setMode={setMode} openSidebar={openSidebar} mode={mode} />
//       <div className="main">
//         <Navbar
//           mode={mode}
//           setSearch={setSearch}
//           toggleSidebar={toggleSidebar}
//           downloadZip={downloadZip}
//         />
        
//         {mode === "dashboard" && (
//           <Dashboard data={data} selected={selected} status={status} />
//         )}
//         {mode === "guidelines" && <Guidelines />}
//         {mode === "verify" && <VerifyCert />}
//         {mode === "help" && <HelpSupport />}
//         {mode === "settings" && <Settings />}
//         {mode === "profile" && <Profile />}

//         {(mode === "offer" || mode === "certificate") && (
//           <>
//             <h2> </h2>
//             <div
//               className={`uploadBox ${drag ? "active" : ""}`}
//               onDragEnter={() => setDrag(true)}
//               onDragLeave={() => setDrag(false)}
//               onDragOver={(e) => e.preventDefault()}
//               onDrop={(e) => {
//                 e.preventDefault();
//                 const file = e.dataTransfer.files[0];
//                 handleExcel(file);
//               }}
//               onClick={() => document.getElementById("fileInput").click()}
//             >
//               <p>📂 Drag & Drop Excel File Here</p>
//               <span>or click to upload</span>

//               <input
//                 id="fileInput"
//                 type="file"
//                 accept=".xlsx, .xls"
//                 style={{ display: "none" }}
//                 onChange={(e) => handleExcel(e.target.files[0])}
//               />
//             </div>

//             <div className="topControls">
//               <select onChange={(e) => setFilterKey(e.target.value)}>
//                 <option value="">All Columns</option>
//                 {data[0] &&
//                   Object.keys(data[0]).map((k) => <option key={k}>{k}</option>)}
//               </select>

//               <div className="stats">
//                 <span>Total: {data.length}</span>
//                 <span>Filtered: {filteredData.length}</span>
//                 <span>Selected: {selectedCount}</span>
//               </div>
//             </div>

//             <div>
//               <button className="btn" onClick={selectAll}>Select All</button>
//               <button className="btn" onClick={deselectAll}>Deselect</button>
//               <button className="btn" onClick={sendEmails} disabled={loading}>
//                 {loading ? <span className="loader"></span> : "📤 Send"}
//               </button>
//             </div>

//             <div className="tableWrap">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Select</th>
//                     {filteredData[0] &&
//                       Object.keys(filteredData[0].row).map((k) => (
//                         <th key={k}>{k}</th>
//                       ))}
//                     <th>Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {filteredData.map(({ row, index }) => (
//                     <tr key={index}>
//                       <td>
//                         <input
//                           type="checkbox"
//                           checked={selected[index] || false}
//                           onChange={() => toggle(index)}
//                         />
//                       </td>

//                       {Object.values(row).map((val, j) => (
//                         <td key={j}>{highlightText(val)}</td>
//                       ))}

//                       <td>
//                         <span className={status[index] === "Sent" ? "sent" : "pending"}>
//                           {status[index] || "Pending"}
//                         </span>
//                       </td>

//                       <td>
//                         <button onClick={() => setPreview(row)}>👁</button>
//                         <button onClick={() => downloadPDF(row)}>⬇</button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </>
//         )}

//         {selectedCount > 0 && (
//           <div className="bulkBar">
//             {selectedCount} selected
//             <button onClick={sendEmails}>Send</button>
//           </div>
//         )}

//         {preview && (
//           <div className="modal">
//             <div className="modalBox">
//               <h2>Preview</h2>
//               <p>{preview.Name}</p>
//               <button onClick={() => setPreview(null)}>Close</button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default App;





import React, { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import Sidebar from "./Sidebar";
import Dashboard from "./Dashboard";
import Navbar from "./Navbar";
import Guidelines from "./Guidlines";
import VerifyCert from "./Verify_Cert";
import HelpSupport from "./Help_Support";
import Settings from "./Setting";
import Profile from "./Profile";

// 🔥 Hamare naye API services ko import kiya (loginAdmin function add kiya)
import { 
  uploadExcelData, 
  sendBulkEmails, 
  downloadStudentPDF, 
  downloadCertificatesZip,
  loginAdmin,
  logoutAdmin 
} from "./api/service";

import "./styles.css";

function App() {
  // 🔒 Authentication States
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState({});
  const [mode, setMode] = useState("dashboard");
  const [status, setStatus] = useState({});
  const [preview, setPreview] = useState(null);
  const [openSidebar, setOpenSidebar] = useState(false);

  // 🔍 search + debounce
  const [search, setSearch] = useState("");
  const [debounced, setDebounced] = useState("");
  const [drag, setDrag] = useState(false);
  // 📊 column filter
  const [filterKey, setFilterKey] = useState("");

  const [loading, setLoading] = useState(false);

  // 🔄 Check if token exists on load
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(search), 250);
    return () => clearTimeout(t);
  }, [search]);

  // 🔑 Handle Admin Login
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await loginAdmin(email, password);
      // if (res.data.token) {
      //   localStorage.setItem("token", res.data.token); // Browser me token save kiya
      //   setIsAuthenticated(true);
      // }
      if (res.success || localStorage.getItem("token")) {
        setIsAuthenticated(true); // Direct access, no refresh needed!
      }
    } catch (err) {
      alert(err.response?.data?.message || "Login Failed! Sahi credentials daalo ❌");
    }
  };

  // 🚪 Handle Logout
  const handleLogout = () => {
    logoutAdmin();
    setIsAuthenticated(false);
    // setData([]);
    // setSelected({});
  };

  // Handle Excel Logic (Common for Drag-Drop and Browse)
  const handleExcel = (file) => {
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (evt) => {
      const wb = XLSX.read(evt.target.result, { type: "binary" });
      const sheet = wb.Sheets[wb.SheetNames[0]];

      const json = XLSX.utils
        .sheet_to_json(sheet, { defval: "" })
        .filter((row) => Object.values(row).join("").trim() !== "");

      // 🔥 Backend ko data bhejo (Using Central API)
      try {
        await uploadExcelData(json);
        console.log("Excel sent to server ✅");
      } catch (err) {
        console.error("Error sending excel ❌", err);
      }

      // State updates
      const init = {};
      json.forEach((_, i) => (init[i] = true));
      setData(json);
      setSelected(init);
    };

    reader.readAsBinaryString(file);
  };

  // 🔍 highlight text
  const highlightText = (text) => {
    if (!debounced) return text;
    const regex = new RegExp(`(${debounced})`, "gi");
    return text
      ?.toString()
      .split(regex)
      .map((part, i) =>
        part.toLowerCase() === debounced.toLowerCase() ? (
          <span key={i} className="highlight">
            {part}
          </span>
        ) : (
          part
        )
      );
  };

  const toggleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  // FILTER + INDEX SAFE
  const filteredData = useMemo(() => {
    return data
      .map((row, index) => ({ row, index }))
      .filter(({ row }) => {
        const value = filterKey ? row[filterKey] : Object.values(row).join(" ");
        return value
          ?.toString()
          .toLowerCase()
          .includes(debounced.toLowerCase());
      });
  }, [data, debounced, filterKey]);

  // Toggle checkbox
  const toggle = (i) => {
    setSelected((prev) => ({ ...prev, [i]: !prev[i] }));
  };

  const selectAll = () => {
    const all = {};
    data.forEach((_, i) => (all[i] = true));
    setSelected(all);
  };

  const deselectAll = () => {
    const none = {};
    data.forEach((_, i) => (none[i] = false));
    setSelected(none);
  };

  // Send emails
  const sendEmails = async () => {
    const filtered = data.filter((_, i) => selected[i]);

    if (filtered.length === 0) {
      alert("Please select at least one record");
      return;
    }

    try {
      setLoading(true);

      // 🔥 Call Central Email Service
      const res = await sendBulkEmails(filtered, mode);

      // status update
      const updated = { ...status };
      filtered.forEach((item) => {
        const index = data.findIndex((d) => d === item);
        updated[index] = "Sent";
      });
      setStatus(updated);

      alert(res?.data?.message || "Emails Sent Successfully! ✅");
    } catch (error) {
      console.error("Error:", error);
      alert(
        error?.response?.data?.error ||
          error?.message ||
          "Something went wrong ❌"
      );
    } finally {
      // res.status(200).json({ success: true });
      setLoading(false);
    }
  };

  // Download PDF
  const downloadPDF = async (student) => {
    try {
      // 🔥 Call Central PDF Service
      const res = await downloadStudentPDF(student, mode);

      const blob = new Blob([res.data], { type: "application/pdf" });
      // const blob = new Blob([res], { type: "application/pdf" }); // Direct resource match
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${student.Name}.pdf`;
      a.click();
    } catch (err) {
      alert("Download failed ❌");
      console.error(err);
    }
  };

  // Download ZIP
  const downloadZip = async () => {
    const filtered = data.filter((_, i) => selected[i]);

    if (filtered.length === 0) {
      alert("Select at least one record");
      return;
    }

    try {
      // 🔥 Call Central ZIP Service
      const res = await downloadCertificatesZip(filtered);

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "certificates.zip";
      a.click();
    } catch (err) {
      console.error(err);
      alert("ZIP download failed ❌");
    }
  };

  const selectedCount = Object.values(selected).filter(Boolean).length;

  // 🔒 IF NOT AUTHENTICATED, RENDER LOGIN SCREEN
  if (!isAuthenticated) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "#f0f2f5" }}>
        <form onSubmit={handleLogin} style={{ background: "#fff", padding: "40px", borderRadius: "12px", boxShadow: "0 8px 24px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", gap: "20px", width: "350px" }}>
          <h2 style={{ textAlign: "center", margin: 0, color: "#1b2a5e", fontFamily: "sans-serif", fontWeight: "700" }}>CodRexa Portal</h2>
          <p style={{ textAlign: "center", color: "#666", fontSize: "14px", marginTop: "-15px" }}>Admin Dashboard Access</p>
          
          <input 
            type="email" 
            placeholder="Admin Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
            style={{ padding: "12px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "16px" }} 
          />
          
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
            style={{ padding: "12px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "16px" }} 
          />
          
          <button type="submit" style={{ padding: "12px", background: "#1b2a5e", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}>
            Sign In
          </button>
        </form>
      </div>
    );
  }

  // 🏠 IF AUTHENTICATED, RENDER DASHBOARD
  return (
    <div className="app">
      <Sidebar setMode={setMode} openSidebar={openSidebar} mode={mode} handleLogout={handleLogout} />
      <div className="main">
        <Navbar
          mode={mode}
          setSearch={setSearch}
          toggleSidebar={toggleSidebar}
          downloadZip={downloadZip}
        />
        
        {mode === "dashboard" && (
          <Dashboard data={data} selected={selected} status={status} />
        )}
        {mode === "guidelines" && <Guidelines />}
        {mode === "verify" && <VerifyCert />}
        {mode === "help" && <HelpSupport />}
        {mode === "settings" && <Settings />}
        {mode === "profile" && <Profile />}

        {(mode === "offer" || mode === "certificate") && (
          <>
            <h2> </h2>
            <div
              className={`uploadBox ${drag ? "active" : ""}`}
              onDragEnter={() => setDrag(true)}
              onDragLeave={() => setDrag(false)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                const file = e.dataTransfer.files[0];
                handleExcel(file);
              }}
              onClick={() => document.getElementById("fileInput").click()}
            >
              <p>📂 Drag & Drop Excel File Here</p>
              <span>or click to upload</span>

              <input
                id="fileInput"
                type="file"
                accept=".xlsx, .xls"
                style={{ display: "none" }}
                onChange={(e) => handleExcel(e.target.files[0])}
              />
            </div>

            <div className="topControls">
              <select onChange={(e) => setFilterKey(e.target.value)}>
                <option value="">All Columns</option>
                {data[0] &&
                  Object.keys(data[0]).map((k) => <option key={k}>{k}</option>)}
              </select>

              <div className="stats">
                <span>Total: {data.length}</span>
                <span>Filtered: {filteredData.length}</span>
                <span>Selected: {selectedCount}</span>
              </div>
            </div>

            <div>
              <button className="btn" onClick={selectAll}>Select All</button>
              <button className="btn" onClick={deselectAll}>Deselect</button>
              <button className="btn" onClick={sendEmails} disabled={loading}>
                {loading ? <span className="loader"></span> : "📤 Send"}
              </button>
            </div>

            <div className="tableWrap">
              <table>
                <thead>
                  <tr>
                    <th>Select</th>
                    {filteredData[0] &&
                      Object.keys(filteredData[0].row).map((k) => (
                        <th key={k}>{k}</th>
                      ))}
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredData.map(({ row, index }) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selected[index] || false}
                          onChange={() => toggle(index)}
                        />
                      </td>

                      {Object.values(row).map((val, j) => (
                        <td key={j}>{highlightText(val)}</td>
                      ))}

                      <td>
                        <span className={status[index] === "Sent" ? "sent" : "pending"}>
                          {status[index] || "Pending"}
                        </span>
                      </td>

                      <td>
                        <button onClick={() => setPreview(row)}>👁</button>
                        <button onClick={() => downloadPDF(row)}>⬇</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {selectedCount > 0 && (
          <div className="bulkBar">
            {selectedCount} selected
            <button onClick={sendEmails}>Send</button>
          </div>
        )}

        {preview && (
          <div className="modal">
            <div className="modalBox">
              <h2>Preview</h2>
              <p>{preview.Name}</p>
              <button onClick={() => setPreview(null)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;